import { useState } from "react";
import { client } from "../../services/networking.service";
import { CollectionCode } from "./getCollectionCodes";

interface CollectionCodeUsage {
  used_at: number;
  used_by_store_id: string;
  used_by_user_id: string;
  box_id: string;
  slot_number: number;
  operation: 'collection' | 'return';
  ip_address: string;
  user_agent: string;
}

interface CollectionCodeAuditLog {
  _id: string;
  collection_code_id: string;
  code: string;
  event_type: string;
  event_timestamp: number;
  actor_type: string;
  actor_name: string;
  store_name: string;
  box_name: string;
  slot_number: number;
  operation: string; // "registration" | "keyring_drop_off" | "placement_confirmation" | "collection" | "owner" | "owner_return_code" | "keyring_scan" | "keyring_link"
  error_code?: string;
  success: boolean;
  failure_reason: string;
  request_id?: string;
  createdAt: string;
}

interface CollectionCodeDetailsResponse {
  success: boolean;
  data: {
    code: CollectionCode;
    usage_history: CollectionCodeUsage[];
    audit_logs: CollectionCodeAuditLog[];
    qr_code_data_url: string;
  };
}

export const useGetCollectionCodeDetails = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const getCollectionCodeDetails = async (codeId: string): Promise<CollectionCodeDetailsResponse | null> => {
    setLoading(true);
    setError(null);

    try {
      const url = `/owner/collection-codes/${codeId}`;
      const response = await client.get<CollectionCodeDetailsResponse>(url);

      setLoading(false);
      return response.data;
    } catch (err: any) {
      setLoading(false);
      setError(err.message || 'Failed to fetch collection code details');
      return null;
    }
  };

  return {
    getCollectionCodeDetails,
    loading,
    error,
  };
};

export type { CollectionCodeDetailsResponse, CollectionCodeUsage, CollectionCodeAuditLog };